module.exports = __webpack_public_path__ + "static/img/settle.8e43871.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/settle.png
// module id = 6V+I
// module chunks = 3